export const WORKSPACE_ADMIN_ROLE_ID = 'c075bb49-5d50-4532-9846-f554e437c4e5';
export const GENERAL_ROLE_ID = '1feb00a8-825e-4ff0-9a78-7ad785c83a4f';
export const RESTRICTED_ROLE_ID = '86a834da-c44d-404a-8f4b-ee43d7c895cd';
export const ANONYMOUS_ROLE_ID = '00000000-0000-0000-0000-000000000001';

export const STANDARD_ROLES = [
  { id: WORKSPACE_ADMIN_ROLE_ID, name: 'Workspace Admin' },
  { id: GENERAL_ROLE_ID, name: 'General' },
  { id: RESTRICTED_ROLE_ID, name: 'Restricted' },
  { id: ANONYMOUS_ROLE_ID, name: 'Anonymous' },
];
